import { Model } from '@/clients/http'

import { AttributeHttpParams, AttributeResponses } from '@/types'

export class AttributeModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'ATTRIBUTE_GET_LIST',
    CREATE: 'ATTRIBUTE_CREATE',
    UPDATE: 'ATTRIBUTE_UPDATE',
    DELETE: 'ATTRIBUTE_DELETE',
  }

  public static readonly endpoints = {
    getList: (props?: AttributeHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/attribute',
        params: props?.params,
        query: props?.query,
      }),

    create: (props?: AttributeHttpParams.Create) =>
      this.createEndpoint({
        url: '/api/backoffice/attribute',
        params: props?.params,
        query: props?.query,
      }),

    update: (props?: AttributeHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/attribute/:id',
        params: props?.params,
        query: props?.query,
      }),

    delete: (props?: AttributeHttpParams.Delete) =>
      this.createEndpoint({
        url: '/api/backoffice/attribute/:id',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getList = async (params?: AttributeHttpParams.GetList) => {
    return this.createHttpRequest<AttributeResponses.GetList>({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(params),
        useBearerToken: true,
      },
    })
  }

  public static readonly create = async (params: AttributeHttpParams.Create) => {
    return this.createHttpRequest<AttributeResponses.Create>({
      correlationKey: this.correlations.CREATE,
      payload: {
        method: 'post',
        url: this.endpoints.create(params),
        body: params.body,
        useBearerToken: true,
      },
    })
  }

  public static readonly update = async (params: AttributeHttpParams.Update) => {
    return this.createHttpRequest<AttributeResponses.Update>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(params),
        body: params.body,
        useBearerToken: true,
      },
    })
  }

  public static readonly delete = async (params: AttributeHttpParams.Delete) => {
    return this.createHttpRequest<AttributeResponses.Delete>({
      correlationKey: this.correlations.DELETE,
      payload: {
        method: 'delete',
        url: this.endpoints.delete(params),
        useBearerToken: true,
      },
    })
  }
}
